import { mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled, { css } from 'styled-components';
import RichText from '../rich-text/RichText';

export const Container = styled.div`
  max-width: 970px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 10px 50px 10px;
`;

export const Logo = styled.img``;

export const TitleHeader = styled.section`
  text-align: left;
  margin: 60px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
`;

const textStyles = css`
  text-align: left;
  font-family: ${platform.select(`Arial, sans-serif`, 'inherit')};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;

  h1,
  h2,
  h3 {
    margin-top: 1.2em;
    text-transform: uppercase;
  }

  h1 + h1 {
    margin-top: 0.5em;
  }

  h3 {
    margin-top: 1em;
  }

  small {
    font-style: italic;
    display: block;
  }
`;

export const Policy = styled.article`
  ${textStyles}
`;

export const PolicyContainer = styled(RichText)`
  ${textStyles}

  a {
    text-decoration: underline;
    color: initial;

    &:hover {
      text-decoration: none !important;
      color: initial;

      * {
        text-decoration: none !important;
      }
    }
  }

  p {
    margin: 1em 0;
  }

  h2 + p,
  h3 + p {
    margin-top: 0.5em;
  }

  ul,
  ol {
    padding: 0 0 0 40px;
    line-height: 1.25;

    li {
      margin: 1em 0;
      padding: 0;

      &::marker {
        color: initial;
      }
    }
  }

  figure {
    width: auto !important;
    margin: 0;
  }

  @media (${mobileXLargeMax}) {
    figure {
      overflow-x: auto;
    }
  }

  table {
    table-layout: auto;
    width: 100%;
    border-collapse: collapse;

    @media (${mobileXLargeMax}) {
      overflow-x: auto;
    }
  }

  table th {
    white-space: nowrap;
  }

  table th,
  table td {
    vertical-align: text-top;
    border: 1px solid black;
    padding: 0.5rem;
    text-align: left;
  }

  table td ol,
  table td ul {
    padding-left: 1em;
  }
`;
